<div class="va-card-header">
  <!-- Title w/ Info icon -->
  <mat-card-title [ngClass]="{ 'no-subtitle': !subtitle }">
    {{ title.key | translate: title.params }}
    <ng-container *ngIf="!!info">
      <mat-icon matTooltip="{{ info.key | translate: info.params }}"> info_outline </mat-icon>
    </ng-container>
  </mat-card-title>
  <!-- Subtitle -->
  <mat-card-subtitle *ngIf="!!subtitle">
    {{ subtitle.key | translate: subtitle.params }}
  </mat-card-subtitle>
  <!-- Any additional content to render -->
  <ng-content />
</div>
